import { jsx as _jsx } from "react/jsx-runtime";
import { itemIsHighlightedOnShiftSelectSelector } from "@air/redux-selected-items";
import { memo, useMemo, useState } from "react";
import { AssetCellThumbnail } from "~/components/TableView/NameCell/AssetCellThumbnail";
import { NameCellContent } from "~/components/TableView/NameCell/NameCellContent";
import { DropdownMenuWrapper } from "~/components/TableView/PrivateTableView/DropdownMenuWrapper";
import { PublicAssetNameCellTitle } from "~/components/TableView/PrivateTableView/PublicAssetNameCellTitle";
import { useAirSelector } from "~/utils/ReduxUtils";
export const PublicAssetNameCell = /*#__PURE__*/ memo((param)=>{
    let { isHovering, isSelected, clip, getItemMenuOptions, getSelectionMenuOptions, onItemClick, onItemCmdClick, onCommentsClick, onVersionsClick } = param;
    const itemTitle = clip.title || clip.importedName || "Untitled";
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const isHighlightedFromShiftSelect = useAirSelector((st)=>itemIsHighlightedOnShiftSelectSelector(st, clip.id));
    const shouldShowMenu = !isHighlightedFromShiftSelect && (isHovering || menuIsOpen);
    const _title = useMemo(()=>{
        return /*#__PURE__*/ _jsx(PublicAssetNameCellTitle, {
            id: clip.id,
            title: itemTitle,
            onClick: onItemClick,
            onCmdClick: onItemCmdClick,
            onCommentsClick: onCommentsClick,
            onVersionsClick: onVersionsClick,
            openCommentCount: clip.openCommentCount || 0,
            assetVersionCount: clip.assetVersionCount || 0,
            pagesCount: clip.pages || 0
        });
    }, [
        clip.pages,
        clip.assetVersionCount,
        clip.id,
        clip.openCommentCount,
        itemTitle,
        onCommentsClick,
        onItemClick,
        onItemCmdClick,
        onVersionsClick
    ]);
    const _image = useMemo(()=>{
        return /*#__PURE__*/ _jsx(AssetCellThumbnail, {
            clip: clip,
            description: itemTitle
        });
    }, [
        clip,
        itemTitle
    ]);
    const dataTestId = "ASSET_NAME_CELL";
    const ellipsisMenuOptions = useMemo(()=>getItemMenuOptions({
            trackLocation: "table-item-ellipsis-menu"
        }), [
        getItemMenuOptions
    ]);
    const selectionMenuOptions = getSelectionMenuOptions("table-multi-select-ellipsis-menu");
    const menuOptions = isSelected && selectionMenuOptions.length ? selectionMenuOptions : ellipsisMenuOptions;
    return /*#__PURE__*/ _jsx(NameCellContent, {
        "data-testid": dataTestId,
        title: _title,
        image: _image,
        children: shouldShowMenu && !!menuOptions.length && /*#__PURE__*/ _jsx(DropdownMenuWrapper, {
            options: menuOptions,
            onOpenChange: setMenuIsOpen,
            dataTestId: "".concat(dataTestId, "-menu")
        })
    });
});
PublicAssetNameCell.displayName = "PublicAssetNameCell";
